import React from 'react';
import {
  Spinner,
  SpinnerWrapper,
  Child,
  RelativeWrapper,
} from './secondary-block-loader.styled';

interface Props {
  children: React.ReactChild;
  show: boolean;
  center?: boolean;
  page?: string; //если у страницы специфичный состав и нужно особенное поведение
}

/** Обёртка-лоадер, затемняющая обёрнутый блок, блокирующая его функционал и помещающая поверх лоадер **/
/** Второй вариант block-loader без условного рендера, ломающего местоположение скролла при дозагрузке контента
 *  Также не изменяет свойства children, а использует белый фон для SpinnerWrapper + opacity: 0.6,
 *  снижая нагрузку и предотвращая лишние ререндеры дочерних компонентов **/
export const SecondaryBlockLoader = React.memo(
  ({ children, show, center, page }: Props) => {
    return (
      <RelativeWrapper>
        {show && (
          <SpinnerWrapper center={center}>
            <Spinner />
          </SpinnerWrapper>
        )}
        <Child page={page}>{children}</Child>
      </RelativeWrapper>
    );
  }
);